import { render, staticRenderFns } from "./rating_field.vue?vue&type=template&id=650a5fa1&lang=pug&"
import script from "./rating_field.vue?vue&type=script&lang=js&"
export * from "./rating_field.vue?vue&type=script&lang=js&"
import style0 from "./rating_field.vue?vue&type=style&index=0&id=650a5fa1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports